/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const organisationCandidateProfileSettingsDataSchema = z.object({
	candidateProfileEnabled: z.boolean(),
	candidateProfileCvCollectionEnabled: z.boolean(),
})

export type OrganisationCandidateProfileSettingsDataSchema = z.infer<
	typeof organisationCandidateProfileSettingsDataSchema
>
